import { api } from "@/lib/api";
import { toast } from "sonner";

/** Applicant and screening documents are permission-checked on the server, so fetch with credentials. */
export const openHiringFile = async (id, filename) => {
  try {
    const { data } = await api.get(`/hiring/files/${id}`, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noreferrer";
    if (filename) a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
  } catch (e) {
    toast.error(e.response?.status === 403
      ? "You do not have permission to open this document"
      : "That document could not be opened");
  }
};
